import * as E from "~/renderer/web-components/element";

export class LinearLayout extends E.SFMLElement {
  constructor() {
    super();
  }
}
customElements.define("sfml-linear-layout", LinearLayout);



// WEBPACK FOOTER //
// webpack://SFMLWeb/src/renderer/web-components/layout/linear.ts